import { takeLatest, put, call, select } from 'redux-saga/effects';
import {
    getMessageContent,
    getCMMessageContent,
} from 'yoda-interfaces/lib/Product/BOPISMessageAPI';
import _get from 'lodash/get';

import { selectFeatureFlags } from '../selectors/ContextSelector';
import {
    BOPIS_MSG_GET_SUCCESS,
    BOPIS_MSG_GET_FAILURE,
    BOPIS_MSG_GET_REQUEST,
} from '../actionTypes/BOPISMessageActionTypes';

const fetchDataResponse = (response = []) => {
    const data = _get(response, 'page.grid.placements[0].items[0].html', []);
    return data.length === 0;
};

function* boisMessageSaga() {
    try {
        const { enableCMFragments, enableCmFallBack = false } = yield select(selectFeatureFlags);

        let response = enableCMFragments
            ? yield call(getCMMessageContent)
            : yield call(getMessageContent);

        if (
            enableCMFragments &&
            enableCmFallBack &&
            (response.status === 404 || fetchDataResponse(response.data))
        ) {
            response = yield call(getMessageContent);
            response.fallback = true;
        }
        if (response.status === 200) {
            yield put({ type: BOPIS_MSG_GET_SUCCESS, payload: response });
        } else {
            yield put({ type: BOPIS_MSG_GET_FAILURE, payload: response });
        }
    } catch (error) {
        yield put({ type: BOPIS_MSG_GET_FAILURE, error });
    }
}

const watchBOPISMessageRequest = function* watchBOPISMessageRequest() {
    yield takeLatest(BOPIS_MSG_GET_REQUEST, boisMessageSaga);
};

watchBOPISMessageRequest.sagaName = 'BOPISMessageRequest';

export default watchBOPISMessageRequest;
